import { render, staticRenderFns } from "./collective-gateway-filter.vue?vue&type=template&id=3fd45aa4"
import script from "./collective-gateway-filter.vue?vue&type=script&lang=js"
export * from "./collective-gateway-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports